import { RootState } from "../../store";

export const selectTimeout = (state: RootState, key: string) => state.timeouts.entities[key];
